<h1>Edit Track</h1>
<form class="w100 col gap-16 grow-1" [formGroup]="trackForm">
  <rr-input label="Track Name" formControlName="name"></rr-input>
  <rr-select
    label="Category"
    [options]="categories"
    formControlName="categoryId"
    iconType="image"
    [preselectedValue]="trackForm.get('categoryId').value"
    optionName="name"
    optionValue="id"
  ></rr-select>
  <rr-select
    [options]="statusOptions"
    optionName="name"
    optionValue="id"
    [preselectedValue]="trackForm.get('status').value"
    formControlName="status"
    label="Status of Track"
  ></rr-select>
  <rr-textarea label="Description" formControlName="description"></rr-textarea>
  <div class="w100 col justify-end space-between align-end">
    <span class="tiny"
      >created: {{ created }} |
      {{ track?.creatingUserId | getUsernameById | async }}</span
    >
    <span class="tiny" *ngIf="track?.dateUpdated"
      >updated: {{ updated }} |
      {{ track?.updatingUserId | getUsernameById | async }}</span
    >
  </div>
  <div class="actionrow row gap-8 justify-end w100 align-end grow-1">
    <rr-btn type="Secondary" (click)="cancel()">Cancel</rr-btn>
    <rr-btn type="Primary" (click)="saveTrackData()">Save</rr-btn>
  </div>
</form>
